import api from '@/utils/api'

export default {
    import(formData) {
        return api.uploadFile(`locations/import`, formData)
    },
    getAll() {
        return api.get(`locations/all`)
    }
}
